import { useReactiveVar } from '@apollo/client'
import { userInfo } from 'api/graphQL/reactiveVars/user'
import { getFromLocalStorage } from 'shared/utils/workspaceUtils'

const useBetaWorkspaceToggle = () => {
    const { currentUserInfo } = useReactiveVar(userInfo)
    const { kpUserId: userId } = currentUserInfo

    const isBetaWorkspaceToggleEnabled = getFromLocalStorage(
        userId ?? '',
        'Global',
        'betaWorkspaceToggleChecked'
    )

    return isBetaWorkspaceToggleEnabled
}

export default useBetaWorkspaceToggle
